module.exports = __webpack_public_path__ + "static/media/rocket_smoke.4f1c1a1e.svg";